import React, { useState } from 'react';

export default function AssistantSupportCard({
  conversationId,
  messageId,
  onFeedback,
  onTryAgain,
}) {
  const [rating, setRating] = useState(null);
  const [nextActions, setNextActions] = useState(false);
  const [error, setError] = useState('');

  const sendRating = async (next) => {
    setRating(next);
    setError('');
    try {
      await onFeedback(next, { messageId });
      setNextActions(next === 'down');
    } catch (err) {
      setError(err.message || 'Could not save feedback');
    }
  };

  return (
    <div className="border-t border-gray-100 pt-2 space-y-2">
      <div className="flex items-center gap-2">
        <p className="text-xs text-gray-500">Was this helpful?</p>
        <button
          type="button"
          className={`px-2 py-1 text-xs rounded border ${rating === 'up' ? 'bg-green-100 border-green-300' : 'border-gray-300'}`}
          aria-label="This helped"
          disabled={!conversationId}
          onClick={() => sendRating('up')}
        >
          Helpful
        </button>
        <button
          type="button"
          className={`px-2 py-1 text-xs rounded border ${rating === 'down' ? 'bg-amber-100 border-amber-300' : 'border-gray-300'}`}
          aria-label="This didn't help"
          disabled={!conversationId}
          onClick={() => sendRating('down')}
        >
          Not helpful
        </button>
      </div>

      {nextActions ? (
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            className="px-2 py-1 text-xs border border-gray-300 rounded"
            onClick={() => {
              setNextActions(false);
              if (onTryAgain) onTryAgain();
            }}
          >
            Try again
          </button>
        </div>
      ) : null}
      {error ? <p className="text-xs text-red-700">{error}</p> : null}
    </div>
  );
}
